<template>
  <div class="auth-error">
    <div class="auth-error__icon">
      <svg width="54" height="49" viewBox="0 0 54 49" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M27 0L53.5 49H0.5L27 0Z"
          fill="var(--text-color2)"
          opacity="0.35"
        />
        <path
          d="M27 18V28"
          stroke="var(--text-color1)"
          stroke-width="3"
          stroke-linecap="round"
        />
        <circle cx="27" cy="36" r="2" fill="var(--text-color1)" />
      </svg>
    </div>
    <h2 class="auth-error__title">{{ $t("auth-error-title") }}</h2>
    <p class="auth-error__description">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: "AuthErrorPage",
  props: {
    message: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.auth-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 40px 24px;
  background: var(--background-color);
  text-align: center;
}

.auth-error__icon {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
  animation: auth-pulse 2s ease-in-out infinite;
}

.auth-error__title {
  font-family: "SF Pro Text Bold", "SF Pro Text", sans-serif;
  font-size: 18px;
  line-height: 1.3;
  color: var(--text-color1);
  margin-bottom: 16px;
}

.auth-error__description {
  font-family: "SF Pro Text", sans-serif;
  font-size: 14px;
  line-height: 1.4;
  color: var(--text-color2);
  max-width: 270px;
}

@keyframes auth-pulse {
  0%,
  100% {
    opacity: 0.7;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
}
</style>
